import React, { FC, useState } from 'react';
import withLocalization from '../hoc/withLocalization';
import { useMediaQuery } from 'react-responsive';
import ParticipationDetails from '../ParticipationDetails/ParticipationDetails';
import './PackageCollapseDetails.scss';
import './PackageOverview.scss';
import { replacePlaceholder, capitalizeFirstLetter } from '../../util/CommonLogic';
import ParseHtml from '../common/ParseHtml';
import PackageOverviewSummary from './PackageOverviewSummary';
import isAsia from '../../util/isAsia';
interface SearchPanelProps {
  localize?: any;
  localizeImages?: any;
  history: any;
  packageData: any;
  isTr: boolean;
  showSummaryDetails?: boolean;
}
const PackageCollapseDetails: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { packageData, localize, isTr, showSummaryDetails = true } = props;
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const [participationModalOpen, setParticipationModalOpen] = useState(false);
  const maxguestContent = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-max-guests-label');
  const updatedContent = replacePlaceholder(maxguestContent, '{guests}', `${packageData?.maxGuest}`);
  const accommodationText = packageData?.accommodation || '';
  const updatedAccomodation = capitalizeFirstLetter(accommodationText);
  const stayText = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-days-nights-label');
  const updatedDays = replacePlaceholder(stayText, '{days}', packageData?.days);
  const updatedStay = replacePlaceholder(updatedDays, '{nights}', packageData?.nights);

  const openParticipationModal = () => {
    setParticipationModalOpen(true);
  };

  const closeModal = () => {
    setParticipationModalOpen(false);
  };
  const tnrDisclaimer = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-overview-disclaimer-tnr')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-surcharge-disclaimer-tnr');
  const trDisclaimer = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-overview-disclaimer')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-surcharge-disclaimer');
  return (
    <>
      {participationModalOpen && <ParticipationDetails closeModal={closeModal} />}
      <div className="packageOverviewContentWrapper">
        <div className="packageCommonRow">
          <span className="packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.stay-label')}
          </span>
          <span className="packageDescContent">{updatedStay}</span>
        </div>
        <div className="packageCommonRow">
          <span className="packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.intl.validity-label')}
          </span>
          <span className="packageDescContent">{`Travel within ${packageData?.dates} months`}</span>
        </div>
        <div className="packageCommonRow">
          <span className="packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.package-summary-accommodation-label')}
          </span>
          <span className="packageDescContent">{updatedAccomodation}</span>
        </div>
        <div className="packageCommonRow">
          <span className="packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.intl.capacity-label')}
          </span>
          <span className="packageDescContent">
            <ParseHtml htmlInput={updatedContent}></ParseHtml>
          </span>
        </div>
        {packageData?.tourGift && (
          <div className="packageCommonRow">
            <span className="packageHeaderContent">
              {localize('preview-sales-engine.static-content.copy.pbeo.package-summary-gift-label')}
            </span>
            <span className="packageDescContent">{`${packageData?.tourGift}`}</span>
          </div>
        )}
        <div className="packageOverviewDiveder"></div>
        {showSummaryDetails && <PackageOverviewSummary packageData={packageData} />}
        <div className="packageBodyContainer">
          {isTr ? (
            <span
              className="packageBodyTextWrapper"
              dangerouslySetInnerHTML={{
                __html: trDisclaimer,
              }}
            ></span>
          ) : (
            <span
              className="packageBodyTextWrapper"
              dangerouslySetInnerHTML={{
                __html: tnrDisclaimer,
              }}
            ></span>
          )}
          <div className="packageBodyLinkContainer">
            <button className="packageBodyLinkText" onClick={() => openParticipationModal()}>
              {localize('preview-sales-engine.static-content.copy.pbeo.intl.view-terms-label')}
            </button>
          </div>
        </div>
        {isMobile && <div className="packageOverviewDiveder"></div>}
      </div>
    </>
  );
};
export default withLocalization(PackageCollapseDetails);
